<template lang="pug">
  v-dialog(v-model="dialog" persistent max-width="500")
    v-card(style="border-radius: 10px")
      v-card-title(class="text-h5 pt-8 px-8")
        div(class="text-center")
          img(src="../assets/warning1.png")
          h3(class="title-alert py-2") Izin Kerja Masih Berjalan
          p(class="word-wrap info1") 
            | Pekerja 
            span(class="highlighted-text") {{ karyawan.name }} ({{ karyawan.ktpNumber }}) 
            | masih terkait dengan izin kerja yang sedang berjalan 
            span(class="highlighted-text") ({{ dataValidasi.ipNo }}) 
            | di Departemen 
            span(class="highlighted-text") {{ dataValidasi.department }} 
            | hingga 
            span(class="highlighted-text") {{ dataValidasi.ipEstimateEnd }}.
          p(class="word-wrap info2 px-15") 
            | Untuk informasi lebih lengkap silahkan hubungi Departmen STC PT BIB. 
            a(:href="whatsappUrl" target="_blank" style="color: #ED1B24; text-decoration: none;") Disini

      v-card-actions(class="justify-center")
        v-btn(class="mb-8 text-none px-15" dark color="#ED1B24" @click="close") Kembali

  </template>
  
  <script>
  export default {
    props: {
      value: { // This makes it work with v-model
        type: Boolean,
        default: false
      },
      karyawan: {
        type: Object,
        default: () => ({
          name: '',
          ktpNumber: ''
        })
      },
      dataValidasi: {
        type: Object,
        default: () => ({
          ipNo:'',
          department:'',
          ipEstimateEnd:''
        })
      },
      company: {
        type: String,
        default: ''
      },
      otherCompany: {
        type: String,
        default: ''
      },
      whatsappLink: {
        type: String,
        default: ''
      }
    },
    computed: {
      dialog: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      },
      whatsappUrl() {
        const message = `Hallo, saya tidak dapat melakukan pengajuan waskat, apakah bisa dibantu?%0A%0A` +
                        `Pekerja ${this.karyawan.name} (${this.karyawan.ktpNumber}) masih terikat dengan izin kerja yang sedang berjalan ` +
                        `(${this.dataValidasi.ipNo}) di Departemen ${this.dataValidasi.department}, hingga ${this.dataValidasi.ipEstimateEnd}.`;
        const waNumber = process.env.VUE_APP_WA_NUMBER; // Get the WhatsApp number from the environment variable
        return `https://wa.me/${waNumber}?text=${encodeURIComponent(message)}`;
      }
    },
    methods: {
      close() {
        this.dialog = false
      }
    }
  }
  </script>
  
  <style scoped>
  .highlighted-text{
    color: #ED1B24;
    font-weight: bold;
  }
  
  </style>